// Added by Sejune Oh on 2019-06-12
// Copyright (c) Coreline Soft, All rights are reserved.
//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { FC } from 'react'
import { createStyles, withStyles, WithStyles, Theme } from '@material-ui/core'
import classNames from 'classnames'

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
import { MultiSelectBaseCProps } from './MultiSelectContainer'
import { RED_COLOR } from '@/styles/Theme'

interface MultiSelectFCProps extends WithStyles<typeof styles>, MultiSelectBaseCProps {
    isErrorOccured?: boolean
    errMessage?: string
    isFullWidth?: boolean
    disabled?: boolean
    isSelectStyle?: boolean
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
const MultiSelect: FC<MultiSelectFCProps> = ({ classes, isFullWidth, isSelectStyle, disabled, ...props }) => {
    return (
        <div
            className={classNames(classes.SelectWrapper, {
                [classes.FullWidthSelectWrapper]: isFullWidth,
                [classes.PaddingSelectWrapper]: isSelectStyle
            })}
        >
            <div className={classes.SelectBoxWrapper}>
                <span className={classNames(classes.ErrLine, props.isErrorOccured ? '' : classes.ErrLineHide)} />
                <div
                    className={classNames(classes.SelectTitleWrapper, props.isErrorOccured ? classes.ErrOccured : '', disabled ? classes.Disabled : '', {
                        [classes.NormalSelectTitleWrapper]: isSelectStyle
                    })}
                >
                    {props.title}
                    {props.isRequired && <span className={classes.SelectRequired}>*</span>}
                </div>
                {props.children}
            </div>
            <span className={classNames(classes.ErrWrapper, props.isErrorOccured ? classes.ErrOccured : '')} data-cy-multiselect-err={props.isErrorOccured}>
                {props.errMessage}
            </span>
        </div>
    )
}

//////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
// Styles
const styles = (theme: Theme) =>
    createStyles({
        SelectWrapper: {
            zIndex: 2,
            position: 'relative',
            padding: '24px 12px 20px 12px',
            minWidth: '50%',
        },
        FullWidthSelectWrapper: {
            minWidth: '100%',
        },
        PaddingSelectWrapper: {
            padding: '23px 0'
        },
        SelectTitleWrapper: {
            color: '#fff',
            fontWeight: 'bold',
            letterSpacing: '1px',
            padding: 0,
            left: '3px',
            top: `-20px`,
            lineHeight: 1,
            transition:
                'color 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
            transform: 'translate(0, 1.5px)',
            transformOrigin: 'top left',
            position: 'absolute',
        },
        NormalSelectTitleWrapper: {
            fontWeight: 'normal',
            top: '-23px',
            letterSpacing: '0px'
        },
        SelectBoxWrapper: {
            position: 'relative',
        },
        SelectRequired: {
            marginLeft: '2px',
        },
        ErrWrapper: {
            position: 'absolute',
            bottom: 0,
            height: '12px',
            marginTop: '8px',
            lineHeight: '1em',
            color: 'transparent',
        },
        ErrOccured: {
            color: RED_COLOR,
        },
        ErrLine: {
            position: 'absolute',
            left: 0,
            right: 0,
            bottom: 0,
            top: 0,
            border: `2px solid ${RED_COLOR}`,
            borderRadius: '4px',
            zIndex: 1,
            transition:
                'border 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms,transform 200ms cubic-bezier(0.0, 0, 0.2, 1) 0ms',
            pointerEvents: 'none',
        },
        ErrLineHide: {
            border: '0px',
        },
        Disabled: {
            color: 'rgba(255, 255, 255, 0.3)'
        }
    })

export default withStyles(styles, { withTheme: true })(MultiSelect)
